export default __webpack_public_path__ + "static/media/social-telegram.4801b46a.png";